import script from "./MsgBoxInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgBoxInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MsgBoxInfo.vue?vue&type=style&index=0&id=c2b63e06&lang=css"

const __exports__ = script;

export default __exports__